export default __webpack_public_path__ + "static/media/userBad.18f04088.svg";